module.exports = __webpack_public_path__ + "static/media/schwangerschaftsvorsorge.a8b781a4.jpg";